/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getList = (buildingId, payload, callback) =>
  req.list(
    c.GET_APPRAISAL_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_property_appraisals?isPaginate=1`,
    payload,
    callback
  );

export const showAppraisalData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_APPRAISAL_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_property_appraisals/${id}`,
    payload,
    callback
  );

export const createData = (buildingId, payload, callback) =>
  req.create(
    c.CREATE_APPRAISAL_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_property_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (id, buildingId, payload, callback) =>
  req.update(
    c.UPDATE_APPRAISAL_DATA,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}/building_property_appraisals/${buildingId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE_LIST,
    'api/v1/rpt/administrator/settings/actual_uses?status=1',
    payload,
    callback
  );

export const getFloorArea = (buildingId, payload, callback) =>
  req.list(
    c.GET_FLOOR_AREA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas`,
    payload,
    callback
  );

export const getApplicationsList = (payload, callback) =>
  req.list(
    c.GET_APPLICATIONS_LIST,
    '/api/v1/rpt/administrator/buildings/building_applications',
    payload,
    callback
  );

export const showData = (id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `/api/v1/rpt/administrator/buildings/building_applications/${id}`,
    payload,
    callback
  );